import { render, staticRenderFns } from "./learner-list.vue?vue&type=template&id=649a2aeb&scoped=true"
import script from "./learner-list.ts?vue&type=script&lang=ts&external"
export * from "./learner-list.ts?vue&type=script&lang=ts&external"
import style0 from "./learner-list.scss?vue&type=style&index=0&id=649a2aeb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a2aeb",
  null
  
)

export default component.exports